import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { WarningAlert } from "../ui";
import { getPerfil } from "../../crud/transportador/perfil.crud";
import { PERMISSIONS } from "../../utils/Permissions";
import { hasPermission } from "../../utils/Utils";
import { EVENTO_LOCALIZACAO_ATUALIZADA, temLocalizacaoExata } from "../../utils/localizacao";
import styles from "./LocalizacaoPendenteAlert.module.css";

export default function LocalizacaoPendenteAlert() {
	const permissions = useSelector((state) => state.auth.permissions);
	const podeDefinirLocalizacao = hasPermission(permissions, PERMISSIONS.EMBARCADORA.EMPRESA_UPDATE_LOCATION);
	const [localizacaoPendente, setLocalizacaoPendente] = useState(false);

	const verificarLocalizacao = useCallback(() => {
		getPerfil()
			.then(({ data }) => {
				const ehArmazem = Boolean(data?.emp_flag_embarcador_armazem);
				setLocalizacaoPendente(ehArmazem && !temLocalizacaoExata(data.emp_latitude, data.emp_longitude));
			})
			.catch(() => {});
	}, []);

	useEffect(() => {
		if (!podeDefinirLocalizacao) return undefined;

		verificarLocalizacao();
		window.addEventListener(EVENTO_LOCALIZACAO_ATUALIZADA, verificarLocalizacao);

		return () => window.removeEventListener(EVENTO_LOCALIZACAO_ATUALIZADA, verificarLocalizacao);
	}, [podeDefinirLocalizacao, verificarLocalizacao]);

	if (!podeDefinirLocalizacao || !localizacaoPendente) {
		return null;
	}

	return (
		<WarningAlert className={styles.wrapper}>
			<span>Defina a localização do armazém no mapa para orientar os motoristas e acompanhar a localização dos motoristas.</span>
			<Link to="/embarcador/minha-empresa" className={styles.botaoDefinir}>Definir localização</Link>
		</WarningAlert>
	);
}
